import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      logEvent(analytics, "page_view", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

export default AnalyticsTracker;
